<script lang="ts">
	import type { SbLink } from '../types';
	import type { ISbStoryData } from '@storyblok/js';
	import ButtonV3 from './buttonV3.svelte';

	interface Props {
		content: ISbStoryData<{
			text: string;
			theme: string;
			link: SbLink;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<ButtonV3 content={{ ...content, size: 'btn-large', type: 'btn-secondary', alignment: 'center' }} />
